module.exports = __webpack_public_path__ + "static/22-97f04c9ef9b9953747490d32404529ee.jpg";